import Vue from 'vue'
import guideBrowserVue from './guide-browser'

const GuideBrowser = {
  // 是否挂载
  instance: null,
  close: () => {
    if (!GuideBrowser.instance) return
    GuideBrowser.instance.visible = false
  },
  show: () => {
    if (!GuideBrowser.instance) {
      const ToastConstructor = Vue.extend(guideBrowserVue)
      GuideBrowser.instance = new ToastConstructor({
        el: document.createElement('div')
      })
      document.body.appendChild(GuideBrowser.instance.$el)
    }
    GuideBrowser.instance.setLocale()
    GuideBrowser.instance.visible = true
  },
  install() {
    Object.defineProperty(Vue.prototype, '$guideBrowser', {
      get: () => GuideBrowser
    })
  }
}
export default GuideBrowser
